import { computerCommandMenuItemSelectedEvent, getComputerMenuItemSelectedValue, } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/commandMenuEvents.js';
import { isComputerMenuItemAllowed } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/computerMenuModel.js';
import { assertNever } from '#pplx/frontend/common/type_utils/unreachableValue.js';
/** @returns `handoff` when Model opens its replacement; otherwise selects normally. */
export function selectComputerCommandMenuItem(item, selectionMethod, { editor, isFollowUp, isAlwaysIncognitoRequired, onSelect, onUiActionSelect, resolvedSearchQuery, track, }) {
    switch (item.action.type) {
        case 'ui_action':
            switch (item.action.actionId) {
                case 'open_model_selector':
                    if (isComputerMenuItemAllowed(item, isFollowUp, isAlwaysIncognitoRequired)) {
                        switch (selectionMethod) {
                            case 'button':
                                break;
                            case 'keyboard':
                            case 'row':
                                track(computerCommandMenuItemSelectedEvent({
                                    name: 'computer command menu item selected',
                                    data: {
                                        item: item.action.type,
                                        value: getComputerMenuItemSelectedValue(item),
                                        section: item.type,
                                        selection_method: selectionMethod,
                                        has_search_query: resolvedSearchQuery.length > 0,
                                    },
                                }));
                                break;
                            default:
                                assertNever(selectionMethod);
                        }
                        editor.deleteActiveTrigger();
                        onUiActionSelect(item.action.actionId);
                        return 'handoff';
                    }
                    return;
                case 'switch_to_search_mode':
                case 'open_computer_settings':
                case 'toggle_incognito':
                case 'open_feedback':
                case 'open_side_chat':
                case 'fork_session':
                    return onSelect(item, selectionMethod);
                default:
                    return assertNever(item.action.actionId);
            }
        case 'skill':
        case 'slash_command':
        case 'connector':
        case 'plugin':
            return onSelect(item, selectionMethod);
        default:
            return assertNever(item.action);
    }
}
//# sourceMappingURL=computerCommandMenuSelection.js.map